export const FETCH_ZONE_REPORT_REQUEST = "FETCH_ZONE_REPORT_REQUEST"
export const FETCH_ZONE_REPORT_SUCCESS = "FETCH_ZONE_REPORT_SUCCESS"
export const FETCH_ZONE_REPORT_FAILED = "FETCH_ZONE_REPORT_FAILED"